import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { Messages } from '../../services/notification-service/notification-messages';
import { NotificationService } from '../../services/notification-service/notification.service';
import { UserGroupsService } from '../../services/user-groups-service/user-groups.service';
import { UserGroupsActions } from './user-groups.actions';

@Injectable()
export class UserGroupsEffects {
  loadUserGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserGroupsActions.loadUserGroups),
      mergeMap(() =>
        this.userGroupsService.getUserGroups().pipe(
          map((groups) =>
            UserGroupsActions.loadUserGroupsSuccess({
              groups,
            }),
          ),
          catchError(() => {
            this.notificationService.error(Messages.PROBLEM_LOADING_USER_DATA);
            return of(
              UserGroupsActions.loadUserGroupsError({
                error: Messages.PROBLEM_LOADING_USER_DATA,
              }),
            );
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private userGroupsService: UserGroupsService,
    private notificationService: NotificationService,
  ) {}
}
